<template>
    <div>
        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs" id="tabs" role="tablist">
            <li class="nav-item" v-for="tab in tabs" :key="tab.name" role="presentation">
                <button class="nav-link" :class="{ active: activeTab === tab.name }" @click="setActiveTab(tab.name)"
                    type="button" role="tab">
                    <img v-if="tab.label == 'Ιδρύματα ιστών'" src="../assets/images/comp16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Μονάδες εφαρμογής'" src="../assets/images/hospital16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Μοσχεύματα'" src="../assets/images/implant16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Προμηθευτές'" src="../assets/images/prov16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    {{ tab.label }}
                </button>
            </li>
        </ul>

        <!-- Tabs Content -->
        <div class="tab-content mt-3">
            <!-- Institutes Tab -->
            <div v-if="activeTab === 'institutes'">
                <div class="d-flex justify-content-start mb-3">

                    <button class="btn me-2" @click="openModalForNew" data-bs-toggle="modal" 
                        data-bs-target="#modal-institutes">
                        <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                         Προσθήκη
                    </button>
                    <button class="btn me-2" @click="handleRefresh('institutes')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                        Ανανέωση</button>
                    <button class="btn " @click="handleExport('institutes')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>
                </div>
                <table class="table table-bordered table-hover table-striped">
                    <tr style="border-bottom: 2px solid gray; "><td style="padding-left:15px">Σύνολο: {{ sortedInstitutions ? sortedInstitutions.length : 0 }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                    <thead class="table-light">
                        <tr>
                            <th @click="sortTable('title')">
                                Iδρυμα
                                <span v-if="sortKey === 'title'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('address')">
                                Διευθυνση
                                <span v-if="sortKey === 'address'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('city')">
                                Πολη
                                <span v-if="sortKey === 'city'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('zip')">
                                Τ.Κ.
                                <span v-if="sortKey === 'zip'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('responsible')">
                                Υπευθυνος
                                <span v-if="sortKey === 'responsible'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('afm')">
                                ΑΦΜ
                                <span v-if="sortKey === 'afm'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('email')">
                                Email
                                <span v-if="sortKey === 'email'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('phone')">
                                Τηλεφωνο
                                <span v-if="sortKey === 'phone'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTable('license_exp')">
                                Ληξη Αδειας
                                <span v-if="sortKey === 'license_exp'">
                                    <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="institution in sortedInstitutions" 
                        :key="institution.id" 
                        @dblclick="handleRowDoubleClick(institution)"
                        style="cursor: pointer;" class="institution-row"> <!-- Pointer cursor to make it act like a button -->
                        <!-- Add a class for targeting -->

                        <td>
                            <img src="../assets/images/comp16.png" alt="Citrine Logo" 
                                class="menu-img" style="width:1.1em; margin-right:10px">
                            {{ institution.title }}
                        </td>
                        <td>{{ institution.address }}</td>
                        <td>{{ institution.city }}</td>
                        <td>{{ institution.zip }}</td>
                        <td>{{ institution.responsible }}</td>
                        <td>{{ institution.afm }}</td>
                        <td>{{ institution.email }}</td>
                        <td>{{ institution.phone }}</td>
                        <td>{{ formatLicenseExp(institution.license_exp) }}</td>
                        <td>
                            <button class="btn-md"
                                @click.stop="preventModalAndOpenDelete($event, institution)" 
                                style=" border:none">
                                <img src="../assets/images/trash16.png" alt="Trash Icon" 
                                    class="menu-img" style="width:1.5em; margin-right:10px">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>


            </div>
            <div v-if="activeTab === 'units'">
                <div class="d-flex justify-content-start mb-3">
                    <button class="btn me-2" @click="openModalForNewHospital" data-bs-toggle="modal"
                        data-bs-target="#modal-hospitals">
                        <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">

                        Προσθήκη
                    </button>
                    <button class="btn me-2" @click="handleRefresh('units')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Ανανέωση</button>
                    <button class="btn" @click="handleExport('units')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>
                </div>
                <table class="table table-bordered table-hover table-striped">
                    <tr style="border-bottom: 2px solid gray; "><td style="padding-left:15px">Σύνολο: {{ sortedHospitals ? sortedHospitals.length : 0 }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                    <thead class="table-light">
                        <tr>
                            <th @click="sortTableHospitals('title')">
                                Μοναδα εφαρμογης
                                <span v-if="sortKeyHospitals === 'title'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('address')">
                                Διευθυνση
                                <span v-if="sortKeyHospitals === 'address'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('city')">
                                Πολη
                                <span v-if="sortKeyHospitals === 'city'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('zip')">
                                Τ.Κ.
                                <span v-if="sortKeyHospitals === 'zip'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('doctor')">
                               Υπευθυνος Υποβολης Δηλωσης
                                <span v-if="sortKeyHospitals === 'doctor'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('email')">
                                Email
                                <span v-if="sortKeyHospitals === 'email'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('afm')">
                                ΑΦΜ
                                <span v-if="sortKeyHospitals === 'afm'">
                                    <i
                                        :class="sortOrderHospitals === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('phone')">
                                Τηλεφωνο
                                <span v-if="sortKeyHospitals === 'phone'">
                                    <i
                                        :class="sortOrderHospitals === 'phone' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableHospitals('license_exp')">
                                Ληξη αδειας
                                <span v-if="sortKeyHospitals === 'license_exp'">
                                    <i
                                        :class="sortOrderHospitals === 'license_exp' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="hospital in sortedHospitals" :key="hospital.id"  @dblclick="handleRowHospitalDoubleClick(hospital)"
                        style="cursor: pointer;" class="hospital-row">
                            <td><img src="../assets/images/hospital16.png" alt="Citrine Logo" 
                                class="menu-img" style="width:1.1em; margin-right:10px">{{ hospital.title }}</td>
                            <td>{{ hospital.address }}</td>
                            <td>{{ hospital.city }}</td>
                            <td>{{ hospital.zip }}</td>
                            <td>{{ hospital.doctor }}</td>
                            <td>{{ hospital.email }}</td>
                            <td>{{ hospital.afm }}</td>
                            <td>{{ hospital.phone }}</td>
                            <td>{{ formatLicenseExp(hospital.license_exp) }}</td>
                            <td>
                                <!-- <button class="btn btn-sm btn-warning me-2" @click="openModalForEditHospital(hospital)"
                                    data-bs-toggle="modal" data-bs-target="#modal-hospitals">
                                    Επεξεργασία
                                </button> -->
                                <button class="btn-md"
                                @click.stop="preventModalAndOpenDeleteHospital($event, hospital)">
                                    <img src="../assets/images/trash16.png" alt="Trash Icon" 
                    class="menu-img" style="width:1.5em; margin-right:10px">
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>


            </div>
            <div v-if="activeTab === 'grafts'">
                <div class="d-flex justify-content-start mb-3">
                    <div class="col-md-4">
                        <div class="d-flex justify-content-start mb-3">
                            <button class="btn me-2" @click="openModalForNewGraftCategory" data-bs-toggle="modal"
                                data-bs-target="#modal-graft-categories">
                                <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                                Nέα κατηγορία
                            </button>
                        </div>
                        <table class="table table-bordered table-hover table-striped" style="margin-right: 5px;">
                            <tr style="border-bottom: 2px solid gray; "><td style="padding-left:15px">Σύνολο: {{ sortedGraftCategories ? sortedGraftCategories.length : 0 }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTableGraftCategories('id')">
                                        Κωδ. κατηγοριας EUTC
                                        <span v-if="sortKeyGraftCategories === 'id'">
                                            <i
                                                :class="sortOrderGraftCategories === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTableGraftCategories('category')">
                                        Κατηγορια EUTC
                                        <span v-if="sortKeyGraftCategories === 'category'">
                                            <i
                                                :class="sortOrderGraftCategories === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="graftCategory in sortedGraftCategories" 
                                :key="graftCategory.id" 
                                @click="changeCategory(graftCategory)"
                                @dblclick="handleRowCategoryDoubleClick(graftCategory)"
                                :class="{ active2: selectedCategory?.id === graftCategory.id }"
                                style="cursor: pointer;">
                                <td>{{ graftCategory.id }}</td>
                                <td>{{ graftCategory.category }}</td>
                                
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="ms-5 col-md-8">
                        <div class="d-flex justify-content-start mb-3">
                            <button class="btn me-2" @click="openModalForNewGraft" data-bs-toggle="modal"
                                data-bs-target="#modal-grafts">
                                <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                                Προσθήκη
                            </button>
                            <button class="btn btn me-2" @click="handleRefresh('grafts')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Ανανέωση</button>
                            <button class="btn btn" @click="handleExport('grafts')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>
                        </div>
                        <table class="table table-bordered table-hover table-striped">
                            <tr style="border-bottom: 2px solid gray; "><td style="padding-left:15px">Σύνολο: {{ sortedGrafts ? sortedGrafts.length : 0 }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTableGrafts('code')">
                                        Κωδικος EUTC
                                        <span v-if="sortKeyGrafts === 'code'">
                                            <i
                                                :class="sortOrderGrafts === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTableGrafts('implant')">
                                        Προϊον EUTC
                                        <span v-if="sortKeyGrafts === 'implant'">
                                            <i
                                                :class="sortOrderGrafts === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="graft in sortedGrafts" :key="graft.id" @dblclick="handleRowGraftDoubleClick(graft)"
                                style="cursor: pointer;" class="institution-row">
                                    <td>{{ graft.code }}</td>
                                    <td>{{ graft.implant }}</td>
                                    <td>
                                        
                                        <button class="btn-md"
                                            @click.stop="preventModalAndOpenDeleteGraft($event, graft)">
                                            <img src="../assets/images/trash16.png" alt="Trash Icon" 
                                            class="menu-img" style="width:1.5em; margin-right:10px">
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Institutes Tab -->
            <div v-if="activeTab === 'suppliers'">
                <div class="d-flex justify-content-start mb-3">
                    <button class="btn me-2" @click="openModalForNewSupplier" data-bs-toggle="modal"
                        data-bs-target="#modal-suppliers">
                        <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                        Προσθήκη
                    </button>
                    <button class="btn me-2" @click="handleRefresh('suppliers')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Ανανέωση</button>
                    <button class="btn" @click="handleExport('suppliers')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>
                </div>
                <table class="table table-bordered table-hover table-striped">
                    <tr style="border-bottom: 2px solid gray; "><td style="padding-left:15px">Σύνολο: {{ sortedSuppliers ? sortedSuppliers.length : 0 }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                    <thead class="table-light">
                        <tr>
                            <th @click="sortTableSupplier('title')">
                                Ιδρυμα
                                <span v-if="sortKeySupplier === 'title'">
                                    <i :class="sortOrderSupplier === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableSupplier('code')">
                                Κωδικος
                                <span v-if="sortKeySupplier === 'code'">
                                    <i :class="sortOrderSupplier === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableSupplier('location')">
                                Χωρα
                                <span v-if="sortKeySupplier === 'location'">
                                    <i :class="sortOrderSupplier === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th @click="sortTableSupplier('origin')">
                                Προελευση
                                <span v-if="sortKeySupplier === 'origin'">
                                    <i :class="sortOrderSupplier === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                </span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="supplier in sortedSuppliers" :key="supplier.id" @dblclick="handleRowSupplierDoubleClick(supplier)" style="cursor: pointer;" class="institution-row">

                            <td><img src="../assets/images/prov16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">{{ supplier.title }}</td>
                            <td>{{ supplier.code }}</td>
                            <td>{{ supplier.origin }}</td>
                            <td>{{ supplier.location }}</td>
                            <td>
                                <button class="btn-md"
                                @click.stop="preventModalAndOpenDeleteSupplier($event, supplier)">
                                    <img src="../assets/images/trash16.png" alt="Trash Icon" 
                                    class="menu-img" style="width:1.5em; margin-right:10px">
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Modal for Institutes -->
        <div class="modal fade" id="modal-hospitals" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Μονάδα εφαρμογής</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Form for Adding/Editing Hospital -->
                        <form @submit.prevent="submitHospitalForm">
                            <div class="row mb-3">
                            <div class="col-2 mt-2">
                                <label for="title" class="form-label">Τίτλος:</label>
                            </div>
                            <div class="col-10">
                                <input type="text" id="title" v-model="formHospital.title" class="form-control"  />
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-2 mt-2">
                                <label for="address" class="form-label">Διεύθυνση:</label>
                            </div>
                            <div class="col-10">
                                <input type="text" id="address" v-model="formHospital.address" class="form-control"  />
                            </div>
                        </div>                      
                                        
                                            <!-- Row 3 -->
                        <div class="row mb-3">
                            <div class="col-2 mt-2">
                                <label for="city" class="form-label">Πόλη:</label>
                            </div>
                            <div class="col-4">
                                <input type="text" id="city" v-model="formHospital.city" class="form-control" />
                            </div>
                            <div class="col-2 mt-2">
                                <label for="zip" class="form-label">Τ.Κ:</label>
                            </div>
                            <div class="col-4">
                                <input type="text" id="zip" v-model="formHospital.zip" class="form-control" />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-4 mt-2">
                                <label for="responsible" class="form-label">Υπεύθυνος Υποβολής Δήλωσης:</label>
                            </div>
                            <div class="col-8 ">
                                <input type="text" id="responsible" v-model="formHospital.doctor"
                                class="form-control"  />            
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-2 mt-2">
                                <label for="email" class="form-label">Email:</label>
                            </div>
                            <div class="col-4">
                                <input type="email" id="email" v-model="formHospital.email" class="form-control"/>            
                            </div>
                            <div class="col-2 mt-2">
                                <label for="phone" class="form-label">Τηλέφωνο:</label>
                            </div>
                            <div class="col-4">
                                <input type="text" id="phone" v-model="formHospital.phone" class="form-control"/>            
                            </div>
                        </div>
                                        
                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                <label for="afm" class="form-label">ΑΦΜ:</label>
                            </div>
                            <div class="col-4">
                                <input type="text" id="afm" v-model="formHospital.afm" class="form-control"  />
                            </div>
                            <div class="col-2 mt-2">
                                <label for="license_exp" class="form-label">Λήξη άδειας:</label>
                            </div>
                            <div class="col-4">
                                <input type="text" id="license_exp" v-model="formHospital.license_exp" class="form-control fp big"  placeholder="ηη/μμ/εεεε"/>
                            </div>
                            </div>
                                                      <div class="mb-3">
                                <label for="institute_relations" class="form-label fw-bold" >
                                    Συσχετισμός ιδρυμάτων ιστών:</label>
                                <!-- select name="institute_relations" multiple class="form-control" v-model="formHospital.inst_ids">
                                    <option v-for="institute in sortedInstitutions" :key="institute.id" :value="institute.id">{{ institute.title }}</option>
                                </select> -->
                                <Select2
                                    v-model="formHospital.inst_ids"
                                    :options="sortedInstitutions2"
                                    :settings="select2Settings"
                                    :multiple="true"
                                    :placeholder="'Ιδρύματα Ιστών'"
                                    class="form-control"
                                
                                />
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                                <button type="submit" class="btn"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Αποθήκευση</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for Institutes -->
        <div class="modal fade" id="modal-graft-categories" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Kατηγορία Μοσχεύματος</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Form for Adding/Editing Institute -->
                        <form @submit.prevent="submitGraftCategoryForm">
                            <div class="mb-3">
                                <label for="title" class="form-label">Τίτλος:</label>
                                <input type="text" id="title" v-model="formGraftCategory.category" class="form-control"  />
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                                <button type="submit" class="btn"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Αποθήκευση</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for Institutes -->
        <div class="modal fade" id="modal-grafts" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Μοσχεύματα</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Form for Adding/Editing Institute -->
                        <form @submit.prevent="submitGraftForm">
                            <div class="mb-3">
                                <label for="title" class="form-label">Κατηγορία:</label>
                                <select v-model="formGraft.catid" class="form-control">
                                     <option v-for="category in sortedGraftCategories" :key="category.id" :value="category.id">{{ category.category }}</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label for="title" class="form-label">Κωδικός:</label>
                                <input type="text" class="form-control" name="code" v-model="formGraft.code" />
                            </div>
                            <div class="mb-3">
                                <label for="title" class="form-label">Μόσχευμα:</label>
                                <input type="text" class="form-control" name="implant" v-model="formGraft.implant" />
                            </div>
                            <div class="mb-3">
                                <label for="title" class="form-label" :class="{'text-muted': isNewGraft, 'fw-bold': !isNewGraft}">Συσχετισμός ιδρυμάτων ιστών:</label>
                               
                                <Select2
                                    v-model="formGraft.institution_ids"
                                    :options="sortedInstitutions2"
                                    :settings="select2Settings"
                                    :multiple="true"
                                    :placeholder="'Ιδρύματα Ιστών'"
                                    class="form-control"
                                />
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                                <button type="submit" class="btn"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Αποθήκευση</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for Suppliers -->
        <div class="modal fade" id="modal-suppliers" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Προμηθευτής</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Form for Adding/Editing Institute -->
                        <form @submit.prevent="submitSupplierForm">
                            <div class="mb-3">
                                <label for="title" class="form-label">Τίτλος:</label>
                                <input type="text" id="title" v-model="formSupplier.title" class="form-control"  />
                            </div>
                            <div class="mb-3">
                                <label for="code" class="form-label">Κωδικός:</label>
                                <input type="text" id="code" v-model="formSupplier.code" class="form-control"  />
                            </div>
                            <div class="mb-3">
                                <label for="origin" class="form-label">Χώρα:</label>
                                <select name="origin" class="form-control" v-model="formSupplier.origin">
                                    <option v-for="country in countries" :key="country.abbr" :value="country.abbr">{{ country.country }}</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label for="institute_relations" class="form-label fw-bold">Συσχετισμός ιδρυμάτων ιστών:</label>
                                
                                <Select2
                                    v-model="formSupplier.inst_ids"
                                    :options="sortedInstitutions2"
                                    :settings="select2Settings"
                                    :multiple="true"
                                    :placeholder="'Ιδρύματα Ιστών'"
                                    class="form-control"

                                />
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                                <button type="submit" class="btn"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Αποθήκευση</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal for Institutes -->
        <div class="modal fade" id="modal-institutes" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ίδρυμα Ιστών</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Form for Adding/Editing Institute -->
                        <form @submit.prevent="submitInstituteForm">
                            
                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                    <label for="title" class="form-label">Τίτλος:</label>
                                </div>
                                <div class="col-10">
                                    <input type="text" id="title" v-model="form.title" class="form-control"  />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                    <label for="address" class="form-label">Διεύθυνση:</label>
                                </div>
                                <div class="col-10">
                                    <input type="text" id="address" v-model="form.address" class="form-control"  />
                                </div>
                            </div>                      
                                            
                                                <!-- Row 3 -->
                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                    <label for="city" class="form-label">Πόλη:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="city" v-model="form.city" class="form-control" />
                                </div>
                                <div class="col-2 mt-2">
                                    <label for="zip" class="form-label">Τ.Κ:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="zip" v-model="form.zip" class="form-control" />
                                </div>
                            </div>

                                                <!-- Row 4 -->
                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                    <label for="responsible" class="form-label">Υπεύθυνος:</label>
                                </div>
                                <div class="col-10 ">
                                    <input type="text" id="responsible" v-model="form.responsible" class="form-control" />
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                    <label for="email" class="form-label">Email:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="email" v-model="form.email" class="form-control" />
                                </div>
                                <div class="col-2 mt-2">
                                    <label for="phone" class="form-label">Τηλέφωνο:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="phone" v-model="form.phone" class="form-control" />
                                </div>
                            </div>
                            

                            <div class="row mb-3">
                                <div class="col-2 mt-2">
                                    <label for="afm" class="form-label">ΑΦΜ:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="afm" v-model="form.afm" class="form-control"  />
                                </div>
                                <div class="col-2 mt-2">
                                    <label for="eurocode" class="form-label">EuroCode:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="eurocode" v-model="form.eurocode" class="form-control"
                                    />            
                                </div>
                            </div>
                        

                            
                            <div class="row mb-3">
                                <div class="col-2">
                                    <label for="fek" class="form-label">Αρ.Άδειας/ΦΕΚ:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="fek" v-model="form.fek" class="form-control"  />
                                </div>
                                <div class="col-2 mt-2">
                                    <label for="license_exp" class="form-label">Λήξη:</label>
                                </div>
                                <div class="col-4">
                                    <input type="text" id="license_exp" v-model="form.license_exp" class="form-control fp big" placeholder="ηη/μμ/εεεε"/>         
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                                <button type="submit" class="btn"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Αποθήκευση</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Confirmation Modal -->
        <div class="modal fade" id="delete-confirmation-modal-hospitals" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Επιβεβαίωση Διαγραφής</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>Είστε σίγουροι ότι θέλετε να διαγράψετε το <strong>{{
                            selectedHospital?.title
                                }}</strong>;</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn2" data-bs-dismiss="modal">OXI</button>
                        <button type="button" class="btn2" @click="confirmDeletionHospital">
                            NAI
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Confirmation Modal -->
        <div class="modal fade" id="delete-confirmation-modal-institutes" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Επιβεβαίωση Διαγραφής</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>Είστε σίγουροι ότι θέλετε να διαγράψετε το ίδρυμα <strong>{{ selectedInstitution?.title}}</strong>;</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn2" data-bs-dismiss="modal">OXI</button>
                        <button type="button" class="btn2" @click="confirmDeletion">
                            NAI
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="delete-confirmation-modal-grafts" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Επιβεβαίωση Διαγραφής</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>Είστε σίγουροι ότι θέλετε να διαγράψετε το <strong>{{ selectedGraft?.implant
                                }}</strong>;</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn2" data-bs-dismiss="modal">OXI</button>
                        <button type="button" class="btn2" @click="confirmDeletionGraft">
                            NAI
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="delete-confirmation-modal-suppliers" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Επιβεβαίωση Διαγραφής</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>Είστε σίγουροι ότι θέλετε να διαγράψετε το <strong>{{ selectedSupplier?.title}}</strong>;</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn2" data-bs-dismiss="modal">OXI</button>
                        <button type="button" class="btn2" @click="confirmDeletionSupplier">
                            NAI
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getInstitutions, postInstitute, deleteInstitutionById, deleteRelationsForInstitute } from "../services/institutions";
import { deleteHospitalById, getHospitals, postHospital } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant } from "@/services/grafts";
import { useToast } from "vue-toastification";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";
import Select2 from "vue3-select2-component";
import flatpickr from 'flatpickr';


export default {
    components: { Select2 },
    data() {
        return {
            activeTab: "institutes",
            tabs: [
                { name: "institutes", label: 'Ιδρύματα ιστών' },
                { name: "units", label: "Μονάδες εφαρμογής" },
                { name: "grafts", label: "Μοσχεύματα" },
                { name: "suppliers", label: "Προμηθευτές" },
            ],
            select2Settings: { multiple: true },
            countries: [],
            suppliers: [],
            hospitals: [],
            institutions: [],
            grafts: [],
            graftCategories: [],
            selectedCategory: null, // To store the currently selected category
            form: {
                id: 0,
                title: "",
                address: "",
                city: "",
                zip: "",
                license: 1,
                responsible: "",
                email: "",
                phone: "",
                afm: "",
                eurocode: "",
                fek: "",
                license_exp: "",
            },
            formHospital: {
                id: 0,
                title: "",
                address: "",
                city: "",
                zip: "",
                license: 1,
                responsible: "",
                email: "",
                phone: "",
                afm: "",
                eurocode: "",
                fek: "",
                license_exp: "",
                inst_ids: [], // Bind selected values

            },
            formGraft: {
                id: 0,
                catid: "",
                code: "",
                implant: ""            
            },
            formSupplier: {
                id: 0,
                catid: "",
                code: "",
                implant: ""            
            },
            formGraftCategory: {
                id: 0,
                category: ""
            },
            graftCatId: 1,
            selectedHospital: null,
            selectedInstitution: null,
            selectedSupplier: null,
            selectedGraft: null,
            sortKey: "title", // Default column to sort by
            sortOrder: "asc", // Default sorting order
            sortKeyHospitals: "title", // Default column to sort by
            sortOrderHospitals: "asc", // Default sorting order
            sortKeyGrafts: "code", // Default column to sort by
            sortOrderGrafts: "asc", // Default sorting order
            sortKeyGraftCategories: "id", // Default column to sort by
            sortOrderGraftCategories: "asc", // Default sorting order
            sortKeySupplier: "title", // Default column to sort by
            sortOrderSupplier: "asc", // Default sorting order
            isNewHospital: false, // Track if modal is opened for a new hospital
            isNewGraft: false, // Track if modal is opened for a new hospital
            isNewSupplier: false, // Track if modal is opened for a new hospital

        };
    },
    computed: {
        sortedInstitutions() {
            if (!this.sortKey) return this.institutions;
            return [...this.institutions].sort((a, b) => {
                const keyA = a[this.sortKey];
                const keyB = b[this.sortKey];
                if (this.sortOrder === "asc") {
                    return keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
                } else {
                    return keyA < keyB ? 1 : keyA > keyB ? -1 : 0;
                }
            });
        },

        sortedInstitutions2() {
      if (!this.sortKey) {
        return this.institutions.map((institute) => ({
          id: institute.id,
          text: institute.title,
        }));
      }
      return [...this.institutions]
        .sort((a, b) => {
          const keyA = a[this.sortKey];
          const keyB = b[this.sortKey];
          if (this.sortOrder === "asc") {
            return keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
          } else {
            return keyA < keyB ? 1 : keyA > keyB ? -1 : 0;
          }
        })
        .map((institute) => ({
          id: institute.id,
          text: institute.title,
        }));
    },
        
     sortedHospitals() {
        if (!Array.isArray(this.hospitals)) return [];
        if (!this.sortKeyHospitals) return this.hospitals;

        return [...this.hospitals].sort((a, b) => {
            const keyA = a[this.sortKeyHospitals];
            const keyB = b[this.sortKeyHospitals];
            return this.sortOrderHospitals === "asc"
            ? keyA > keyB ? 1 : keyA < keyB ? -1 : 0
            : keyA < keyB ? 1 : keyA > keyB ? -1 : 0;
        });
        },


        sortedGrafts() {
            if (!this.sortKeyGrafts) return this.grafts;
            return [...this.grafts].sort((a, b) => {
                const keyA = a[this.sortKeyGrafts];
                const keyB = b[this.sortKeyGrafts];
                if (this.sortOrderGrafts === "asc") {
                    return keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
                } else {
                    return keyA < keyB ? 1 : keyA > keyB ? -1 : 0;
                }
            });
        },
        sortedGraftCategories() {
            if (!this.sortKeyGraftCategories) return this.graftCategories;
            return [...this.graftCategories].sort((a, b) => {
                const keyA = a[this.sortKeyGraftCategories];
                const keyB = b[this.sortKeyGraftCategories];
                if (this.sortOrderGraftCategories === "asc") {
                    return keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
                } else {
                    return keyA < keyB ? 1 : keyA > keyB ? -1 : 0;
                }
            });
        },
        sortedSuppliers() {
            if (!this.sortKeySupplier) return this.suppliers;
            return [...this.suppliers].sort((a, b) => {
                const keyA = a[this.sortKeySupplier];
                const keyB = b[this.sortKeySupplier];
                if (this.sortOrderSupplier === "asc") {
                    return keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
                } else {
                    return keyA < keyB ? 1 : keyA > keyB ? -1 : 0;
                }
            });
        }
    },
    methods: {
        async handleRowCategoryDoubleClick(graftCategory) {
            this.formGraftCategory = {...graftCategory};
            $("#modal-graft-categories").modal('show');
        },
        async changeCategory(graftCategory) {
            this.graftCatId = graftCategory.id;
            this.grafts = (await getGrafts({catid: this.graftCatId})).data.data;
            this.selectedCategory = graftCategory;
        },
        handleRowDoubleClick(institution) {
        // Log the institution for debugging

        // Call the edit modal function
        this.openModalForEdit(institution);
    },

    handleRowHospitalDoubleClick(hospital){
        this.openModalForEditHospital(hospital);

    },

    handleRowGraftDoubleClick(graft){
        this.openModalForEditGraft(graft);

    },
    handleRowSupplierDoubleClick(supplier){
        this.openModalForEditSupplier(supplier);

    },
    
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
        },
        sortTableSupplier(column) {
            if (this.sortKeySupplier === column) {
                // Reverse order if the column is already sorted
                this.sortOrderSupplier = this.sortOrderSupplier === "asc" ? "desc" : "asc";
            } else {
                this.sortKeySupplier = column;
                this.sortOrderSupplier = "asc";
            }
        },
        sortTableHospitals(column) {
            if (this.sortKeyHospitals === column) {
                // Reverse order if the column is already sorted
                this.sortOrderHospitals = this.sortOrderHospitals === "asc" ? "desc" : "asc";
            } else {
                this.sortKeyHospitals = column;
                this.sortOrderHospitals = "asc";
            }
        },
        sortTableGrafts(column) {
            if (this.sortKeyGrafts === column) {
                // Reverse order if the column is already sorted
                this.sortOrderGrafts = this.sortOrderGrafts === "asc" ? "desc" : "asc";
            } else {
                this.sortKeyGrafts = column;
                this.sortOrderGrafts = "asc";
            }
        },
        sortTableGraftCategories(column) {
            if (this.sortKeyGraftCategories === column) {
                // Reverse order if the column is already sorted
                this.sortOrderGraftCategories = this.sortOrderGraftCategories === "asc" ? "desc" : "asc";
            } else {
                this.sortKeyGraftCategories = column;
                this.sortOrderGraftCategories = "asc";
            }
        },
        // Existing methods remain unchanged...
        setActiveTab(tabName) {
            this.activeTab = tabName;
        },
        async handleRefresh(tabName) {
            if (tabName === "institutes") {
                this.institutions = (await getInstitutions()).data.data;
            } else if (tabName == 'units') {
                this.hospitals = (await getHospitals()).data.data;
            } else if (tabName == 'grafts') {
                this.grafts = (await getGrafts({catid: this.graftCatId})).data.data;
            } else if (tabName == 'suppliers') {
                this.suppliers = (await getSuppliers()).data.data;
            }
        },
        handleExport(tabName) {
            if (tabName == 'institutes') {
                const worksheet = XLSX.utils.json_to_sheet(this.institutions.map(institution => ({
                    Ίδρυμα: institution.title,
                    Διεύθυνση: institution.address,
                    Πόλη: institution.city,
                    ΤΚ: institution.zip + "",
                    Υπεύθυνος: institution.responsible,
                    ΑΦΜ: institution.afm + "",
                    Email: institution.email,
                    Τηλέφωνο: institution.phone + "",
                    'Λήξη Άδειας': this.formatLicenseExp(institution.license_exp),
                })));

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Ιδρύματα');

                // Download the Excel file
                XLSX.writeFile(workbook, 'Ιδρύματα.xlsx');
            } else if (tabName === "units") {
                const worksheet = XLSX.utils.json_to_sheet(this.hospitals.map(unit => ({
                    Τίτλος: unit.title,
                    Διεύθυνση: unit.address,
                    Πόλη: unit.city,
                    ΤΚ: unit.zip + "",
                    'Επιστ. Υπεύθυνος': unit.doctor,
                    Email: unit.email,
                    ΑΦΜ: unit.afm + "",
                })));
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Μονάδες εφαρμογής");
                XLSX.writeFile(workbook, "Μονάδες εφαρμογής.xlsx");
            } else if (tabName === "grafts") {
                const worksheet = XLSX.utils.json_to_sheet(this.grafts.map(unit => ({
                    'Κωδικός Προϊόντος EUTC': unit.code,
                    'Προϊόν EUTC': unit.implant
                })));
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Μοσχεύματα");
                XLSX.writeFile(workbook, "Μοσχεύματα.xlsx");
            } else if (tabName === "suppliers") {
                const worksheet = XLSX.utils.json_to_sheet(this.suppliers.map(unit => ({
                    'Προμηθευτής': unit.title,
                    'Κωδικός προμηθευτή': unit.code,
                    'Χώρα': unit.origin,
                    'Προέλευση': unit.location
                })));
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Προμηθευτές");
                XLSX.writeFile(workbook, "Προμηθευτές.xlsx");
            }
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        openModalForNew() {
            this.clearForm();

            $("#modal-institutes").modal('show');

            this.$nextTick(() => {
                this.fpInstance = flatpickr('.fp', {
                    altFormat: "d/m/Y",
                    dateFormat: 'Y/m/d',
                    allowInput: true,
                    altInput: true,
                })[0];

                if (this.fpInstance) {
                    this.fpInstance.clear(); // <-- important
                }
            });
        },
        openModalForNewSupplier() {
            this.clearFormSupplier();
            this.isNewSupplier = true; // Mark as new

        },
        openModalForNewHospital() {
            this.clearFormHospital();
            this.isNewHospital = true; // Mark as new
        },
        openModalForNewGraft() {
            this.clearFormGraft();
            this.isNewGraft = true; // Mark as new

        },
        openModalForNewGraftCategory() {
            this.clearFormGraftCategory();
        },
        openModalForEditSupplier(supplier) {
            this.formSupplier = { ...supplier };
            this.isNewSupplier = false; // Mark as edit

            $("#modal-suppliers").modal('show');

        },
        openModalForEditGraft(graft) {

            this.formGraft = { ...graft };
            this.isNewGraft = false; // Mark as edit

            $("#modal-grafts").modal('show');

        },
        openModalForEditHospital(hospital) {
            this.formHospital = { ...hospital };
            this.isNewHospital = false; // Mark as edit
            $("#modal-hospitals").modal('show');
        },
        openModalForEdit(institution) {
            this.form = { ...institution };

            $("#modal-institutes").modal('show');

            this.$nextTick(() => {
                this.fpInstance = flatpickr('.fp', {
                    altFormat: "d/m/Y",
                    dateFormat: 'Y/m/d',
                    allowInput: true,
                    altInput: true,
                })[0];

                if (this.fpInstance) {
                    this.fpInstance.setDate(this.form.license_exp);
                }
            });
        },
        preventModalAndOpenDeleteHospital(event, hospital) {
            event.preventDefault(); // Prevent any default behavior
            event.stopPropagation(); // Stop the event from propagating
            event.stopImmediatePropagation(); // Stop the event from propagating
            this.openDeleteConfirmationHospital(hospital); // Call your delete logic
        },
        preventModalAndOpenDeleteSupplier(event, supplier) {
            event.preventDefault(); // Prevent any default behavior
            event.stopPropagation(); // Stop the event from propagating
            event.stopImmediatePropagation(); // Stop the event from propagating
            this.openDeleteConfirmationSupplier(supplier); // Call your delete logic
        },
        preventModalAndOpenDeleteGraft(event, graft) {
            event.preventDefault(); // Prevent any default behavior
            event.stopPropagation(); // Stop the event from propagating
            event.stopImmediatePropagation(); // Stop the event from propagating
            this.openDeleteConfirmationGraft(graft); // Call your delete logic
        },
        openDeleteConfirmationSupplier(supplier) {
            this.selectedSupplier = supplier;
            const modal = $("#delete-confirmation-modal-suppliers");
            modal.modal("show");
        },
        openDeleteConfirmationGraft(graft) {
            this.selectedGraft = graft;
            const modal = $("#delete-confirmation-modal-grafts");
            modal.modal("show");
        },
        openDeleteConfirmationHospital(hospital) {
            this.selectedHospital = hospital;
            const modal = $("#delete-confirmation-modal-hospitals");
            modal.modal("show");
        },
        async confirmDeletionGraft() {
            const response = await actImplant({id: this.selectedGraft.id, isactive: 0});
            if (response.data.success) {
                const r2 = await deleteRelationsForImplant({id: this.selectedGraft.id});
                this.grafts = (await getGrafts({catid: this.graftCatId})).data.data;
                $("#delete-confirmation-modal-grafts").modal('hide');
                useToast().success("Το μόσχευμα διαγράφηκε επιτυχώς.");
            } else {
                useToast().error("Το μόσχευμα διαγράφηκε επιτυχώς.");
            }
        },
        async confirmDeletionSupplier() {
            const response = await actProvider({id: this.selectedSupplier.id, isactive: 0});
            if (response.data.success) {
                const r2 = await deleteRelationsForProvider({id: this.selectedSupplier.id});
                this.suppliers = (await getSuppliers()).data.data;
                $("#delete-confirmation-modal-suppliers").modal('hide');
                useToast().success("O προμηθευτής διαγράφηκε επιτυχώς");
            } else {
                useToast().error("Προέκυψε κάποιο σφάλμα!");
            }
        },
        async confirmDeletionHospital() {
            const response = await deleteHospitalById({id: this.selectedHospital.id, isactive: 0});
            if (response.data.success) {
                this.hospitals = this.hospitals.filter(
                    (item) => item.id !== this.selectedHospital.id
                );
                this.selectedHospital = null;
                this.hospitals = (await getHospitals()).data.data;
                $("#delete-confirmation-modal-hospitals").modal('hide')
                useToast().success("Η μονάδα εφαρμογής διαγράφηκε επιτυχώς.");
            } else {
                useToast().error("Αποτυχία διαγραφής ιδρύματος.");
            }
        },
        preventModalAndOpenDelete(event, institution) {
            event.preventDefault(); // Prevent any default behavior
            event.stopPropagation(); // Stop the event from propagating
            event.stopImmediatePropagation(); // Stop the event from propagating
            this.openDeleteConfirmation(institution); // Call your delete logic
        },
        openDeleteConfirmation(institution) {
            this.selectedInstitution = institution;
            const modal = $("#delete-confirmation-modal-institutes");
            modal.modal("show");
        },
        async confirmDeletion() {
            const response = await deleteInstitutionById(this.selectedInstitution.id);
            if (response.data.success) {
                const response2 = await deleteRelationsForInstitute(this.selectedInstitution.id);
                this.institutions = this.institutions.filter(
                    (item) => item.id !== this.selectedInstitution.id
                );
                this.selectedInstitution = null;
                $("#delete-confirmation-modal-institutes").modal('hide')
                useToast().success("Το ίδρυμα διαγράφηκε επιτυχώς.");
            } else {
                useToast().error("Αποτυχία διαγραφής ιδρύματος.");
            }
        },
        async submitGraftCategoryForm() {
            const response = await postCategory(this.formGraftCategory);
            if (response.data.success) {
                this.graftCategories = (await getGraftCategories()).data.data;
                $("#modal-graft-categories").modal('hide');
                useToast().success("Οι αλλαγές αποθηκεύτηκαν επιτυχώς!");
            } else {
                useToast().error("Προέκυψε κάποιο σφάλμα!");
            }
        },
        async submitGraftForm() {
            const response = await postImplant(this.formGraft);
            if (!this.formGraft.implant || this.formGraft.implant == '') {
                useToast().error('Το πεδίο μόσχευμα είναι απαραίτητο');
                return;
            }
            if (!this.formGraft.code || this.formGraft.code == '') {
                useToast().error('Το πεδίο κωδικός είναι απαραίτητο');
                return;
            }
            if (response.data.success) {
                $("#modal-grafts").modal('hide');
                useToast().success("Οι αλλαγές αποθηκεύτηκαν επιτυχώς!");
                this.grafts = (await getGrafts({catid: this.graftCatId})).data.data;
            } else {
                useToast().error("Προέκυψε κάποιο σφάλμα!");
            }
        },
        async submitHospitalForm() {
            if (!this.formHospital.title || this.formHospital.title == '') {
                useToast().error('O τίτλος είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.formHospital.email || this.formHospital.email == '') {
                useToast().error('Το email είναι απαραίτητο πεδίο');
                return;
            }
             if (!this.formHospital.doctor || this.formHospital.doctor == '') {
                useToast().error('O Υπεύθυνος είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.formHospital.address || this.formHospital.address == '') {
                useToast().error('Η Διεύθυνση είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.formHospital.city || this.formHospital.city == '') {
                useToast().error('Η Πόλη είναι απαραίτητο πεδίο');
                return;
            }
           
            if (!this.formHospital.license_exp || this.formHospital.license_exp == '') {
                useToast().error('Η Ημ/νια Λήξης Άδειας είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.formHospital.zip || this.formHospital.zip == '') {
                useToast().error('O T.K. είναι απαραίτητο πεδίο');
                return;
            } else if ((this.formHospital.zip + "").length != 5) {
                useToast().error('O T.K. πρέπει να αποτελείται από 5 ψηφία.');
                return;
            }
            if (!this.formHospital.afm || this.formHospital.afm == '') {
                useToast().error('O ΑΦΜ είναι απαραίτητο πεδίο');
                return;
            } else if ((this.formHospital.afm + "").length != 9) {
                useToast().error('O ΑΦΜ πρέπει να αποτελείται από 9 ψηφία.');
                return;
            }
            const response = await postHospital(this.formHospital);
            if (response.data.success) {
                this.hospitals = (await getHospitals()).data.data;
                $("#modal-hospitals").modal('hide');
                useToast().success("Οι αλλαγές αποθηκεύτηκαν επιτυχώς!");
            } else {
                useToast().error(response.data.message);
            }
        },
        async submitInstituteForm() {
            if (!this.form.title || this.form.title == '') {
                useToast().error('O τίτλος είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.email || this.form.email == '') {
                useToast().error('Το email είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.responsible || this.form.responsible == '') {
                useToast().error('O Υπεύθυνος είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.address || this.form.address == '') {
                useToast().error('Η Διεύθυνση είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.city || this.form.city == '') {
                useToast().error('Η Πόλη είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.license || this.form.license == '') {
                useToast().error('Η Άδεια είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.license_exp || this.form.license_exp == '') {
                useToast().error('Η Ημ/νια Λήξης Άδειας είναι απαραίτητο πεδίο');
                return;
            }
            if (!this.form.zip || this.form.zip == '') {
                useToast().error('O T.K. είναι απαραίτητο πεδίο');
                return;
            } else if ((this.form.zip + "").length != 5) {
                useToast().error('O T.K. πρέπει να αποτελείται από 5 ψηφία.');
                return;
            }
            if (!this.form.afm || this.form.afm == '') {
                useToast().error('O ΑΦΜ είναι απαραίτητο πεδίο');
                return;
            } else if ((this.form.afm + "").length != 9) {
                useToast().error('O ΑΦΜ πρέπει να αποτελείται από 9 ψηφία.');
                return;
            }
            const response = await postInstitute(this.form);
            if (response.data.success) {
                this.institutions = (await getInstitutions()).data.data;
                $("#modal-institutes").modal('hide');
                useToast().success("Οι αλλαγές αποθηκεύτηκαν επιτυχώς!");
            } else {
                useToast().error(response.data.message);
            }
        },
        async submitSupplierForm() {
            const response = await postProvider(this.formSupplier);
            if (response.data.success) {
                $("#modal-suppliers").modal('hide');
                useToast().success("Οι αλλαγές αποθηκεύτηκαν επιτυχώς!");
                this.handleRefresh('suppliers');
            } else {
                useToast().error('Παρουσιάστηκε κάποιο σφάλμα!');
            }
        },
        clearFormHospital() {
            this.formHospital = {
                id: 0,
                title: "",
                address: "",
                city: "",
                zip: "",
                responsible: "",
                license: 1,
                email: "",
                phone: "",
                afm: "",
                eurocode: "",
                fek: "",
                license_exp: "",
            };
        },
        clearFormGraftCategory() {
            this.formGraftCategory = {
                id: 0,
                category: ""
            };
        },
        clearFormGraft() {
            this.formGraft = {
                id: 0,
                catid: "",
                code: "",
                implant: ""            
            };
        },
        clearFormSupplier() {
            this.formSupplier = {
                id: 0,
                catid: "",
                code: "",
                implant: ""            
            };
        },
        clearForm() {
            this.form = {
                id: 0,
                title: "",
                address: "",
                city: "",
                zip: "",
                responsible: "",
                license: 1,
                email: "",
                phone: "",
                afm: "",
                eurocode: "",
                fek: "",
                license_exp: "",
            };
        },
    },
    async mounted() {
        this.institutions = (await getInstitutions()).data.data;
        this.hospitals = (await getHospitals()).data.data;
        this.grafts = (await getGrafts({catid: this.graftCatId})).data.data;
        this.graftCategories = (await getGraftCategories()).data.data;
        this.countries = (await getCountries()).data.data;
        this.suppliers = (await getSuppliers()).data.data;
    },
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
}
.btn{
    background-color: #f6f6f6;
}

.btn:hover, .btn-md:hover{
    background-color: #ececec;
}
.btn-md{
    background-color: inherit; /* Inherit background color from parent */
    border:none;
}

.nav-link.active{
    border:none;
}

.modal-header{
   background-color: #6DB4E3;
}

.modal-title{
color:white;
}

.modal-content{
    border:none;
    margin-top:30%;
}
/* Add hover effect for rows */
.institution-row:hover .btn-md {
    background-color: #ececec;
}

.hospital-row:hover .btn-md {
    background-color: #ececec;
}

.btn2{
   background-color: #6DB4E3;
   color:white;
   border:none;
   border-radius:5px;
   padding:10px;
   margin-right:8px;
}

.active2 {
    background-color: #ffefbb; /* Light blue background */
    font-weight: bold; /* Make the text bold */
}

.text-muted {
    opacity: 0.5; /* Makes it look faded */
    cursor: not-allowed; /* Shows "not allowed" cursor */
    font-size: 12px;
}


</style>